import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BookingStatus } from '@contact/upgrade';

import { AgentBookingPhoneAcceptingComponent } from './accepting/agent-booking-phone-accepting.component';
import { AgentBookingPhoneAllocatedComponent } from './allocated/agent-booking-phone-allocated.component';
import { AgentBookingPhoneInprocessConferenceComponent } from './inprocess-conference/agent-booking-phone-inprocess-conference.component';
import { AgentBookingPhoneInprocessForwardComponent } from './inprocess-forward/agent-booking-phone-inprocess-forward.component';
import { AgentBookingPhoneInprocessScriptRedirectionComponent } from './inprocess-script-redirection/agent-booking-phone-inprocess-script-redirection.component';
import { AgentBookingPhoneInprocessComponent } from './inprocess/agent-booking-phone-inprocess.component';
import { AgentBookingPhoneQualificationComponent } from './qualification/agent-booking-phone-qualification.component';

export enum AgentBookinPhoneInprocessState {
  call = 'call',
  forward = 'forward',
  conference = 'conference',
  scriptRedirection = 'script-redirection',
}

const routes: Routes = [
  {
    path: BookingStatus.ACCEPTING.toLowerCase(),
    component: AgentBookingPhoneAcceptingComponent,
  },
  {
    path: BookingStatus.ALLOCATED.toLowerCase(),
    component: AgentBookingPhoneAllocatedComponent,
  },
  {
    path: BookingStatus.IN_PROCESS.toLowerCase(),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: AgentBookinPhoneInprocessState.call,
      },
      {
        path: AgentBookinPhoneInprocessState.call,
        component: AgentBookingPhoneInprocessComponent,
      },
      {
        path: `${AgentBookinPhoneInprocessState.conference}/:${AgentDesktopRouteParams.GuestId.key}`,
        component: AgentBookingPhoneInprocessConferenceComponent,
      },
      {
        path: AgentBookinPhoneInprocessState.forward,
        component: AgentBookingPhoneInprocessForwardComponent,
      },
      {
        path: AgentBookinPhoneInprocessState.scriptRedirection,
        component: AgentBookingPhoneInprocessScriptRedirectionComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: BookingStatus.POST_PROCESSING.toLowerCase(),
    component: AgentBookingPhoneQualificationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentBookingPhoneRoutingModule {}
